'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  string: require('./string'),
  method: require('./method'),
  number: require('./number'),
  "boolean": require('./boolean'),
  regexp: require('./regexp'),
  integer: require('./integer'),
  'float': require('./float'),
  array: require('./array'),
  object: require('./object'),
  'enum': require('./enum'),
  pattern: require('./pattern'),
  email: require('./type'),
  url: require('./type'),
  date: require('./date'),
  hex: require('./type')
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/async-validator/lib/validator/index.js
 ** module id = 566
 ** module chunks = 0
 **/